import React, { useState } from 'react';
import { Card, CardContent } from '../components/Card';
import { Input } from '../components/Input';
import { Textarea } from '../components/Textarea';
import { ARWMButton } from '../components/ARWMButton';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
export function Contact() {
  useSEO("Contact - ARWM | Contactez l'Association des Restaurateurs", "Contactez l'ARWM pour toute question sur l'adhésion, nos services ou la restauration à Marrakech. Notre équipe est à votre écoute.");
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In production, this would send to arestaurateursmarrakech@gmail.com
    console.log('Form submitted:', formData);
    alert('Votre message a été envoyé avec succès !');
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };
  return <div className="w-full" data-id="element-231">
      {/* Hero */}
      <section className="py-32 px-4 bg-arwm-light-gray" data-id="element-232">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-233">
          <h1 className="font-cormorant text-7xl font-bold text-arwm-maroon mb-6" data-id="element-234">
            Contactez-nous
          </h1>
          <p className="font-josefin text-xl text-arwm-dark-text max-w-3xl mx-auto" data-id="element-235">
            Notre équipe est à votre écoute pour répondre à toutes vos questions
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-4 bg-white" data-id="element-236">
        <div className="max-w-[1280px] mx-auto" data-id="element-237">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-238">
            {/* Contact Info */}
            <div data-id="element-239">
              <h2 className="font-cormorant text-4xl font-bold text-arwm-dark-text mb-8" data-id="element-240">
                Informations de Contact
              </h2>

              <div className="space-y-8 mb-12" data-id="element-241">
                <div className="flex items-start space-x-4" data-id="element-242">
                  <div className="w-12 h-12 bg-arwm-maroon flex items-center justify-center flex-shrink-0" data-id="element-243">
                    <Mail className="w-6 h-6 text-arwm-cream" data-id="element-244" />
                  </div>
                  <div data-id="element-245">
                    <h3 className="font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-246">
                      Email
                    </h3>
                    <a href="mailto:arestaurateursmarrakech@gmail.com" className="font-josefin text-arwm-maroon hover:underline" data-id="element-247">
                      arestaurateursmarrakech@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4" data-id="element-248">
                  <div className="w-12 h-12 bg-arwm-maroon flex items-center justify-center flex-shrink-0" data-id="element-249">
                    <Phone className="w-6 h-6 text-arwm-cream" data-id="element-250" />
                  </div>
                  <div data-id="element-251">
                    <h3 className="font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-252">
                      Téléphone
                    </h3>
                    <a href="tel:+212660626515" className="font-josefin text-arwm-maroon hover:underline" data-id="element-253">
                      06 60 62 65 15
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4" data-id="element-254">
                  <div className="w-12 h-12 bg-arwm-maroon flex items-center justify-center flex-shrink-0" data-id="element-255">
                    <MapPin className="w-6 h-6 text-arwm-cream" data-id="element-256" />
                  </div>
                  <div data-id="element-257">
                    <h3 className="font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-258">
                      Adresse
                    </h3>
                    <p className="font-josefin text-arwm-dark-text" data-id="element-259">
                      68 rue Yougoslavie
                      <br data-id="element-260" />
                      Guéliz, Marrakech
                      <br data-id="element-261" />
                      Maroc
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-arwm-light-gray p-8" data-id="element-262">
                <h3 className="font-cormorant text-2xl font-bold text-arwm-dark-text mb-4" data-id="element-263">
                  Horaires d'ouverture
                </h3>
                <div className="space-y-2 font-josefin text-arwm-dark-text" data-id="element-264">
                  <p data-id="element-265">
                    <strong data-id="element-266">Lundi - Vendredi :</strong> 9h00 - 17h00
                  </p>
                  <p data-id="element-267">
                    <strong data-id="element-268">Samedi :</strong> 9h00 - 13h00
                  </p>
                  <p data-id="element-269">
                    <strong data-id="element-270">Dimanche :</strong> Fermé
                  </p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div data-id="element-271">
              <h2 className="font-cormorant text-4xl font-bold text-arwm-dark-text mb-8" data-id="element-272">
                Envoyez-nous un Message
              </h2>

              <Card data-id="element-273">
                <CardContent className="p-8" data-id="element-274">
                  <form onSubmit={handleSubmit} className="space-y-6" data-id="element-275">
                    <div data-id="element-276">
                      <label htmlFor="name" className="block font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-277">
                        Nom complet *
                      </label>
                      <Input id="name" type="text" required value={formData.name} onChange={e => setFormData({
                      ...formData,
                      name: e.target.value
                    })} placeholder="Votre nom" data-id="element-278" />
                    </div>

                    <div data-id="element-279">
                      <label htmlFor="email" className="block font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-280">
                        Email *
                      </label>
                      <Input id="email" type="email" required value={formData.email} onChange={e => setFormData({
                      ...formData,
                      email: e.target.value
                    })} placeholder="votre.email@exemple.com" data-id="element-281" />
                    </div>

                    <div data-id="element-282">
                      <label htmlFor="subject" className="block font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-283">
                        Sujet *
                      </label>
                      <Input id="subject" type="text" required value={formData.subject} onChange={e => setFormData({
                      ...formData,
                      subject: e.target.value
                    })} placeholder="Objet de votre message" data-id="element-284" />
                    </div>

                    <div data-id="element-285">
                      <label htmlFor="message" className="block font-josefin font-semibold text-arwm-dark-text mb-2" data-id="element-286">
                        Message *
                      </label>
                      <Textarea id="message" required value={formData.message} onChange={e => setFormData({
                      ...formData,
                      message: e.target.value
                    })} placeholder="Votre message..." rows={6} data-id="element-287" />
                    </div>

                    <ARWMButton type="submit" className="w-full" data-id="element-288">
                      Envoyer le message
                    </ARWMButton>
                  </form>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Map Placeholder */}
      <section className="h-[400px] bg-arwm-light-gray" data-id="element-289">
        <div className="w-full h-full flex items-center justify-center" data-id="element-290">
          <p className="font-josefin text-arwm-dark-text text-lg" data-id="element-291">
            Carte Google Maps - 68 rue Yougoslavie, Guéliz, Marrakech
          </p>
        </div>
      </section>
    </div>;
}